module.exports = __webpack_public_path__ + "static/img/extend1.f02efe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/extend1.png
// module id = WKpe
// module chunks = 0